import { render, staticRenderFns } from "./DocumentVariablesSolr.vue?vue&type=template&id=53c07bbe&scoped=true"
import script from "./DocumentVariablesSolr.vue?vue&type=script&lang=js"
export * from "./DocumentVariablesSolr.vue?vue&type=script&lang=js"
import style0 from "./DocumentVariablesSolr.vue?vue&type=style&index=0&id=53c07bbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c07bbe",
  null
  
)

export default component.exports